import React, { useEffect } from "react";
import { connect } from "react-redux";
import CMX from "../../../api";
import { CinemaType, MovieType } from "../../../types/entities";
import styled from "styled-components";
import { calculateDistanceInKm, PositionType } from "../../../utils/location";
import ShowtimesLanguageBlock from "./ShowtimesLanguageBlock";
import CinemaMaintenanceLegend from "../CinemaMaintenanceLegend";
import { isUserLogged } from "../../../reducers";
import { dialogAlert } from "../../../actions/creators/dialogs";

const Container = styled.div`
    margin-bottom: var(--pad-y);
    &:last-child {
        margin-bottom: 0;
    }
`;

const Heading = styled.div`
    align-items: flex-start;
    display: flex;
    gap: 1rem;
    margin-bottom: 1rem;
`;

const CinemaName = styled.h4`
    margin: 0;
    font-size: 1.25rem;
    font-weight: 700;
`;

const FavButton = styled.span<{ isFave: boolean }>`
  cursor: pointer;
  ${props => props.isFave && 'color: var(--primary);'}
`;

interface Props {
    alert: (message: string) => void;
    attributes?: { [key: string]: { display_name: string } },
    cinema: {
        cinema: CinemaType
    },
    isFave: boolean;
    isUserLoggedIn: boolean;
    languages?: Array<string>,
    movie: MovieType,
    showtimes: { [lang: string]: { [cinemaId: string]: Array<any> } },
    onCinemaFave: (cinemaId: number, isFave: boolean) => void;
    userLocation?: PositionType | null;
}

const ShowtimesBlockCinema = (props: Props) => {
    const [isFave, setIsFave] = React.useState(props.isFave);
    const { cinema, movie, showtimes, attributes, languages } = props;

    useEffect(() => {
        setIsFave(props.isFave);
    }, [props.isFave]);

    function onCinemaFaveClick(cinema: CinemaType) {
        if (!props.isUserLoggedIn) {
            props.alert('Debes iniciar sesión para poder agregar un cine a tus favoritos.');
            return;
        }

        const newIsFave = !isFave;
        setIsFave(newIsFave);
        onCinemaFave(cinema.id, newIsFave);
    }

    function onCinemaFave(cinemaId: number, isFave: boolean) {
        setIsFave(isFave);
        props.onCinemaFave(cinemaId, isFave);
        CMX[isFave ? 'put' : 'delete'](`/me/cinemas/${cinemaId}`)
            .catch(() => {
                setIsFave(!isFave);
                onCinemaFave(cinemaId, !isFave);
            });
    }

    const hasShowtimes = !!languages && languages.some(lang => showtimes[lang] && showtimes[lang][cinema.cinema.id] && showtimes[lang][cinema.cinema.id].length);

    if (!hasShowtimes) {
        return null;
    }

    return <Container className="fade-in">
        <Heading>
            <FavButton isFave={isFave} onClick={() => {
                onCinemaFaveClick(cinema.cinema);
            }}>
                <i className={`fal fa-heart ${isFave ? 'fa-solid' : ''}`}></i>
            </FavButton>
            <div>
                <CinemaName>
                    {cinema.cinema.name}
                </CinemaName>
                {props.userLocation && (
                    <p>
                        Distancia: {calculateDistanceInKm(props.userLocation, { lat: cinema.cinema.lat, lng: cinema.cinema.lng }).toFixed(2)} km
                    </p>
                )}
            </div>
        </Heading>
        {!!cinema.cinema && 'maintenance' === cinema.cinema.status && <CinemaMaintenanceLegend text={cinema.cinema.maintenance_message} />}
        <div>
            {!!languages && languages.map(lang => attributes && (lang in attributes) && (lang in showtimes) && (cinema.cinema.id in showtimes[lang]) && <ShowtimesLanguageBlock
                key={lang}
                language={attributes[lang].display_name}
                showtimes={showtimes[lang][cinema.cinema.id]}
                cinema={cinema.cinema}
                movie={movie}
            />)}
        </div>
    </Container>;
}

const mapStateToProps = (state: any) => ({
    isUserLoggedIn: isUserLogged(state),
});

const mapDispatchToProps = (dispatch: any) => ({
    alert: (message: string) => dispatch(dialogAlert(message)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ShowtimesBlockCinema);